<script>
import AtomsModal from "~/components/atoms/Modal.vue";
import { useSessionStore } from "~/store/session";
import migrateFundMixin from "~/mixins/migrate-fund";
import { formatUSD } from "~/utils/helpers";

export default {
  components: {
    AtomsModal,
  },

  mixins: [migrateFundMixin],

  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    balance: {
      type: Number,
      required: true,
    },
  },

  setup() {
    const sessionStore = useSessionStore();
    return { sessionStore };
  },

  data() {
    return {
      modal: false,
      amount: null,
    };
  },

  methods: {
    openModal() {
      this.modal = true;
    },
    closeModal() {
      this.modal = false;
      this.$emit("update:modelValue", false);
    },
    clearForm() {
      this.amount = null;
      this.closeModal();
    },
    async migrateFunds() {
      try {
        const amountToMigrate = this.amount;
        await this.migrateFund(amountToMigrate);
      } finally {
        this.clearForm();
      }
    },
    formatUSD(value) {
      return formatUSD(value);
    },
  },
};
</script>

<template>
  <AtomsModal
    :model-value="modelValue"
    title="Transfer Funds to Main"
    @update:modelValue="(e) => $emit('update:modelValue', e)"
  >
    <RiseForm class="flex flex-col gap-4" @submit="migrateFunds">
      <div class="text-gray-700 text-sm">
        Current Balance:
        <span class="font-semibold text-gray-900">
          {{ formatUSD(balance) }}
        </span>
      </div>
      <RiseTextField
        v-model="amount"
        name="amount"
        label="Amount*"
        placeholder="0.00"
        :rules="['required', 'isPaymentAmount', 'isMinimumPaymentAmount']"
        label-size="big"
      />
      <div class="mt-4 flex justify-end gap-2">
        <RiseButton
          variant="tertiary"
          text="Cancel"
          :disabled="loadingMigrateFund"
          @click="$emit('update:modelValue', false)"
        />
        <RiseButton
          text="Transfer"
          type="submit"
          :loading="loadingMigrateFund"
          :disabled="!amount || amount <= 0 || amount > balance"
        />
      </div>
    </RiseForm>
  </AtomsModal>
</template>
